export default __webpack_public_path__ + "static/media/pinterest.9a7af212.svg";